import {useMutation} from '@apollo/react-hooks';

import type {
    CreateEmailSequenceTemplate as CreateEmailSequenceTemplateMutation,
    CreateEmailSequenceTemplateVariables as CreateEmailSequenceTemplateMutationVariables,
    EmailSequenceTemplateCreateInput,
} from 'nutshell-graphql-types';

import CREATE_EMAIL_SEQUENCE_TEMPLATE from '../../../../graphql/mutations/create-email-sequence-template.graphql';

export function useCreateEmailSequenceTemplate(): {
    createEmailSequenceTemplate: (arg1: EmailSequenceTemplateCreateInput) => Promise<any>;
    isCreating: boolean;
} {
    const [createEmailSequenceTemplate, {loading}] = useMutation<
        CreateEmailSequenceTemplateMutation,
        CreateEmailSequenceTemplateMutationVariables
    >(CREATE_EMAIL_SEQUENCE_TEMPLATE);

    return {
        createEmailSequenceTemplate: (input: EmailSequenceTemplateCreateInput) =>
            createEmailSequenceTemplate({
                variables: {emailSequenceTemplate: input},
            }),
        isCreating: loading,
    };
}
